import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Col, Row } from 'react-grid-system';
import { Helmet } from 'react-helmet';
import { useForm } from '@inertiajs/react';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import H1 from '../../atoms/title/H1';
import Panel from '../../atoms/Panel';
import Layout from '../../templates/Layout';
import SideBar from '../../organisms/dossier/SideBar';
import Tabs from '../../organisms/dossier/Tabs';
import Textarea from '../../atoms/Textarea';
import { color } from '../../templates/Ui';
import Notice, { TYPES } from '../../molecules/Notice';
import Button from '../../atoms/Button';
import PaperPlane from '../../atoms/icons/PaperPlane';
import Radio from '../../atoms/Radio';
import Flex from '../../atoms/Flex';
import H2 from '../../atoms/title/H2';
import Download from '../../atoms/icons/Download';
import Paragraph from '../../atoms/Paragraph';
const StyledTextarea = styled(Textarea) `
    border: 1px solid ${color.border.base};
    border-radius: 6px;
    resize: none;
    min-height: 170px;

    &:focus {
        border: 1px solid ${color.border.base};
    }

    &::-webkit-input-placeholder {
        font-style: italic;
    }
    &:-moz-placeholder {
        font-style: italic;
    }
    &::-moz-placeholder {
        font-style: italic;
    }
    &:-ms-input-placeholder {
        font-style: italic;
    }
`;
const StyledDownloadList = styled.ul `
    padding: 0;
    margin: 0 0 2rem 0;
    list-style: none;
`;
const StyledDownloadListItem = styled.li `
    margin-bottom: 1rem;
`;
const StyledDownload = styled.a `
    color: ${props => props.theme.primary.base};
    padding: 10px;
    background-color: #f1f1f1;
    border: 1px solid #e6e6e6;
    border-radius: 6px;
    text-decoration: none;
    transition: all 100ms ease-in-out;
    display: inline-block;
    box-shadow: #59256b00 0 1px 2px 1px;

    &:hover {
        box-shadow: #59256b30 0 1px 2px 1px;
    }

    &:focus {
        transform: translateY(1px);
        box-shadow: #59256b30 0 1px 2px -1px;
    }
`;
const StyledDownloadIcon = styled(Download) `
    fill: ${props => props.theme.primary.base};
    transition: all 100ms ease-in-out;
    margin-left: 1em;
`;
const StyledButton = styled(Button) `
    margin-top: 1.5rem;
`;
const StyledErrorMessage = styled(Paragraph) `
    color: ${color.error.base};
    margin-bottom: 1rem;
`;
const Requests = ({ dossier, dossierNumber, }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const { patch, data, setData, errors, reset, processing } = useForm({
        accept: '1',
        message: null,
        request_id: dossier.request?.id,
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        patch(`/dossier/${dossierNumber}/verzoeken`, {
            preserveScroll: true,
            onSuccess: () => {
                reset();
            },
        });
    };
    const handleChange = (e) => {
        // @ts-ignore
        setData(e.currentTarget.name, e.currentTarget.value);
    };
    return (_jsxs(Layout, { dossierNumber: dossierNumber, children: [_jsx(Helmet, { children: _jsxs("title", { children: ["Verzoek - ", t('dossier.title')] }) }), _jsxs(H1, { "data-testid": "title", children: [t('dossier.title'), " ", dossierNumber] }), _jsxs(Row, { children: [_jsx(Col, { sm: 9, children: _jsxs(Panel, { children: [_jsx(Tabs, { dossier: dossier }), dossier.request?.status !== 'new' && (_jsx(Notice, { type: TYPES.WARNING, title: t('requests.handled.title'), children: t('requests.handled.message') })), _jsxs("form", { onSubmit: handleSubmit, children: [_jsx(H2, { children: t(`requests.type.${dossier.request?.type}.title`) }), _jsx(Paragraph, { children: t(`requests.type.${dossier.request?.type}.intro`) }), dossier.documents && dossier.documents.length > 0 && (_jsx(StyledDownloadList, { children: dossier.documents?.map(document => (_jsx(StyledDownloadListItem, { children: _jsxs(StyledDownload, { href: `/dossier/${dossier.id}/documenten/${document}/by-name`, download: document, "aria-label": t('file.download'), children: ["Download rapport", _jsx(StyledDownloadIcon, { className: "icon" })] }) }, document))) })), errors.message && (_jsx(StyledErrorMessage, { children: errors.message })), _jsxs(Flex, { gap: '1em', children: [_jsx(Radio, { label: t('requests.accept'), value: '1', name: "accept", disabled: processing, checked: data.accept === '1', required: true, onChange: handleChange }), _jsx(Radio, { label: t('requests.deny'), value: '0', name: "accept", disabled: processing, checked: data.accept === '0', required: true, onChange: handleChange })] }), data.accept === '0' && (_jsx(StyledTextarea, { bordered: true, placeholder: "Reden en opdracht om dossier open te houden en te incasseren", name: "message", disabled: processing, onChange: handleChange, value: data.message || '', required: data.accept === '0' })), _jsx(StyledButton, { type: "submit", isLoading: processing, tertiary: true, icon: _jsx(PaperPlane, {}), 
                                            //@ts-ignore
                                            loaderColor: theme.primary.dark, children: "Besluit verzenden" })] })] }) }), _jsx(Col, { sm: 3, children: _jsx(SideBar, { dossier: dossier }) })] })] }));
};
export default Requests;
